import React, { useState } from 'react';

import { Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';

import { addWebsitePage, removeWebsitePage } from 'actions/website';
import { FAQ_PAGE_TYPE } from 'components/modules/pages/constants';
import usePages from 'components/modules/pages/hooks/use-pages';
import { useQuestionsContext } from 'components/modules/questions/context';
import API from 'libs/api';
import { selectWebsite } from 'selectors/website';

import FaqsPageEmpty from './components/FaqsPageEmpty';
import FaqsPageHeader from './components/FaqsPageHeader';
import FaqsPageSuccess from './components/FaqsPageSuccess';
import { FaqsPageTabProvider } from './context';

import './FaqsPageTab.scss';

const propTypes = {};
const defaultProps = {};

export default function FaqsPageTab() {
  const dispatch = useDispatch();

  const { showMessage } = useQuestionsContext();

  const website = useSelector(selectWebsite);
  const { id: websiteId } = website || {};

  const { pages, loading, refreshPages } = usePages({
    fetchPagesOnMount: true,
    fetchRecipeSettingsOnMount: false,
  });

  const [creating, setCreating] = useState(false);

  const faqPage = pages.find((p) => p.pageType === FAQ_PAGE_TYPE);
  const hasFaqPage = !_isEmpty(faqPage);

  async function onCreateFaqsPage() {
    setCreating(true);
    try {
      const payload = {
        title: 'FAQs',
        slug: 'faqs',
        pageType: FAQ_PAGE_TYPE,
        navigationPriority: pages.length + 1,
      };
      const createdPage = await API.createPage(websiteId, payload);
      dispatch(addWebsitePage(createdPage));
      await refreshPages();
      showMessage('FAQs page created successfully', 'success');
    } catch (e) {
      showMessage('Failed to create FAQs page', 'error');
    } finally {
      setCreating(false);
    }
  }

  async function onDeleteFaqsPage() {
    if (!faqPage?.id) {
      return;
    }
    try {
      await API.deletePage(websiteId, faqPage.id);
      const index = pages.findIndex((p) => p.id === faqPage.id);
      if (index >= 0) {
        dispatch(removeWebsitePage({ index }));
      }
      await refreshPages();
      showMessage('FAQs page deleted successfully', 'success');
    } catch (e) {
      showMessage('Failed to delete FAQs page', 'error');
    }
  }

  const contextValue = {
    loading,
    creating,
    faqPage,
    hasFaqPage,
    websiteId,
    onCreateFaqsPage,
    onDeleteFaqsPage,
  };

  return (
    <FaqsPageTabProvider value={contextValue}>
      <div className="faqs-page-tab">
        <FaqsPageHeader />

        {loading && (
          <div className="loading-state">
            <Icon name="spinner" loading /> Loading...
          </div>
        )}
        {!loading && !hasFaqPage && <FaqsPageEmpty />}
        {!loading && hasFaqPage && <FaqsPageSuccess />}
      </div>
    </FaqsPageTabProvider>
  );
}

FaqsPageTab.propTypes = propTypes;
FaqsPageTab.defaultProps = defaultProps;
